import { ITab } from 'shared/components/buttons/tab-button/tab-button-interface';

export enum RunActivityTab {
  SHIFT_ACTIVITY = 'shift-activity',
  SHIFT_SUB_LOCATIONS = 'shift-sub-locations',
  CONSIGNMENTS = 'consignments',
  VEHICLE_CHECKS = 'vehicle-checks',
}

export const runActivityTabs: ITab[] = [
  {
    label: 'Shift Activity',
    key: RunActivityTab.SHIFT_ACTIVITY,
  },
  {
    label: 'Consignments',
    key: RunActivityTab.CONSIGNMENTS,
  },
  {
    label: 'Vehicle Checks',
    key: RunActivityTab.VEHICLE_CHECKS,
  },
];
